export default __webpack_public_path__ + "static/Prom_Visiomate_Portfolio_ERP-d89bebe54da45e6f5c0074f0c0b75ec8.pdf";